import "react-perfect-scrollbar/dist/css/styles.css";

import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";

export default ({ title = "Right Sidebar", children }) => {
  const rightBarNodeRef = useRef();

  useEffect(() => {
    document.addEventListener("mousedown", handleOtherClick, false);
    return () => {
      document.removeEventListener("mousedown", handleOtherClick, false);
    };
  }, []);

  const handleClose = e => {
    e.preventDefault();
    hide();
  };

  /**
   * Handle the click anywhere in doc
   */
  const handleOtherClick = e => {
    if (rightBarNodeRef && rightBarNodeRef.current.contains(e.target)) return;
    // else hide the right sidebar
    hide();
  };

  /**
   * Hide rightside bar
   */
  const hide = () => {
    document.body.classList.remove("right-bar-enabled");
  };

  return (
    <React.Fragment>
      <div className="right-bar" ref={rightBarNodeRef}>
        <div className="rightbar-title">
          <Link to="#" className="right-bar-toggle float-right" onClick={handleClose}>
            <i className="dripicons-cross noti-icon"></i>
          </Link>
          <h5 className="m-0 text-white">{title}</h5>
        </div>
        <PerfectScrollbar>{children}</PerfectScrollbar>
      </div>
      <div className="rightbar-overlay" />
    </React.Fragment>
  );
};
